// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownContainer_JWsVS {
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding: 0 !important;
}

.dropdownButton_c3ACk {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: row;
	width: 200px;
	color: #666;
	border-radius: 5px;
	background-color: var(--f5-background);
	padding: 0px 15px;
	height: 45px;
	border: none;
	cursor: pointer;
	gap: 8px;
}

.leftContainer_DYpx0 {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 14px;
	font-weight: 600;
	font-size: 14px;
	svg {
		width: 18px;
		height: 18px;
		margin-bottom: 1px;
	}
}
.leftContainerMd_Hu9ZU {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 14px;
	font-weight: 600;
	font-size: 14px;
	svg {
		width: 20px;
		height: 20px;
		margin-bottom: 1px;
	}
}


.dropdownButton_c3ACk:hover {
	background-color: var(--_16c0982e-background);
}

.dropdownMenu_BAsbS {
	position: absolute;
	overflow: hidden;
	top: 45px;
	left: 0px;
	background-color: var(--f5-background);
	box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
	border-radius: 5px;
	z-index: 100;
	width: 200px;
	padding: 0px !important;
}

.dropdownItem_i3eMh {
	padding: 10px !important;
	display: flex;
	align-items: center;
	color: #666;
	font-size: 14px;
	gap: 14px;
	font-weight: 600;
	transition: background 0.2s ease-in-out;
	cursor: pointer;
	&:hover {
		background-color: var(--_16c0982e-background);
	}
	svg {
		width: 18px;
		height: 18px;
		margin-bottom: 1px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/NormalDropdown.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,aAAa;CACb,8BAA8B;CAC9B,uBAAuB;CACvB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,mBAAmB;CACnB,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,sCAAsC;CACtC,iBAAiB;CACjB,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,SAAS;CACT,gBAAgB;CAChB,eAAe;CACf;EACC,WAAW;EACX,YAAY;EACZ,kBAAkB;CACnB;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,SAAS;CACT,gBAAgB;CAChB,eAAe;CACf;EACC,WAAW;EACX,YAAY;EACZ,kBAAkB;CACnB;AACD;;;AAGA;CACC,6CAA6C;AAC9C;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,SAAS;CACT,SAAS;CACT,sCAAsC;CACtC,2CAA2C;CAC3C,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,uBAAuB;AACxB;;AAEA;CACC,wBAAwB;CACxB,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,eAAe;CACf,SAAS;CACT,gBAAgB;CAChB,uCAAuC;CACvC,eAAe;CACf;EACC,6CAA6C;CAC9C;CACA;EACC,WAAW;EACX,YAAY;EACZ,kBAAkB;CACnB;AACD","sourcesContent":[".dropdownContainer {\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: flex-start;\n\tpadding: 0 !important;\n}\n\n.dropdownButton {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tflex-direction: row;\n\twidth: 200px;\n\tcolor: #666;\n\tborder-radius: 5px;\n\tbackground-color: var(--f5-background);\n\tpadding: 0px 15px;\n\theight: 45px;\n\tborder: none;\n\tcursor: pointer;\n\tgap: 8px;\n}\n\n.leftContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 14px;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tmargin-bottom: 1px;\n\t}\n}\n.leftContainerMd {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 14px;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tmargin-bottom: 1px;\n\t}\n}\n\n\n.dropdownButton:hover {\n\tbackground-color: var(--_16c0982e-background);\n}\n\n.dropdownMenu {\n\tposition: absolute;\n\toverflow: hidden;\n\ttop: 45px;\n\tleft: 0px;\n\tbackground-color: var(--f5-background);\n\tbox-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n\tborder-radius: 5px;\n\tz-index: 100;\n\twidth: 200px;\n\tpadding: 0px !important;\n}\n\n.dropdownItem {\n\tpadding: 10px !important;\n\tdisplay: flex;\n\talign-items: center;\n\tcolor: #666;\n\tfont-size: 14px;\n\tgap: 14px;\n\tfont-weight: 600;\n\ttransition: background 0.2s ease-in-out;\n\tcursor: pointer;\n\t&:hover {\n\t\tbackground-color: var(--_16c0982e-background);\n\t}\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tmargin-bottom: 1px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownContainer": `dropdownContainer_JWsVS`,
	"dropdownButton": `dropdownButton_c3ACk`,
	"leftContainer": `leftContainer_DYpx0`,
	"leftContainerMd": `leftContainerMd_Hu9ZU`,
	"dropdownMenu": `dropdownMenu_BAsbS`,
	"dropdownItem": `dropdownItem_i3eMh`
};
export default ___CSS_LOADER_EXPORT___;
